import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { MockDataService } from "src/app/shared/services/mock-data.service";

/**
 * Mock Backend Interceptor
 * يعطل جميع الطلبات HTTP إلى الباك إند عند تفعيل DISABLE_BACKEND في environment
 * ويرجع بيانات وهمية واقعية من MockDataService
 */
@Injectable()
export class MockBackendInterceptor implements HttpInterceptor {
    
    constructor(private mockDataService: MockDataService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // التحقق من flag تعطيل الباك إند
        if ((environment as any).DISABLE_BACKEND === true) {
            console.group('🚫 Mock Backend Interceptor');
            console.log('Method:', req.method);
            console.log('URL:', req.url);
            console.log('Body:', req.body);
            
            // الحصول على بيانات وهمية من MockDataService
            const mockResponse = this.mockDataService.getMockData(
                req.url, 
                req.method, 
                req.body
            );
            
            console.log('📦 Mock Response:', JSON.stringify(mockResponse, null, 2));
            console.log('📦 Mock Response Type:', typeof mockResponse);
            console.groupEnd();
            
            // إرجاع HttpResponse - Angular HttpClient يقوم تلقائياً باستخراج body عند استخدام lastValueFrom
            return of(new HttpResponse({
                status: 200,
                statusText: 'OK',
                body: mockResponse,
                url: req.url
            }));
        }
        
        // إذا كان الباك إند مفعّل، اترك الطلب يمر بشكل عادي
        return next.handle(req);
    }
}

